<template>
  <div class="row" :key="componentKey">
    <div class="col col-md-12">
      <p
        v-if="loadGif == false && quantidadeItens == 0"
        style="margin-bottom: 0px"
      >
        ------
      </p>

      <div v-if="loadGif && quantidadeItens == 0" style="margin-bottom: 0px">
        <img src="/assets/load4.gif" style="max-height: 64px" />
      </div>

      <div class="rowLista rowListaEventosHome">
        <div
          v-for="(item, itemIndex) in itensFiltro"
          :key="item.id"
          :item="item"
        >
          <div
            class="list-group-item d-flex justify-content-start"
            style="
              padding-top: 2px;
              padding-bottom: 4px;
              padding-left: 10px;
              margin-top: 10px;
            "
            v-if="
              itemIndex == 0 ||
              itensFiltro[itemIndex - 1].competicao !== item.competicao
            "
          >
            <span>
              <img
                :src="item.competicaoPaisUrl"
                height="20"
                alt="Brazil"
                style="max-height: 15px; border: solid 1px; margin-top: 0px"
              />
            </span>
            <h6
              v-if="item.competicao && item.competicao !== ''"
              class="text-primary text-left"
              style="
                margin: 0px;
                padding: 0px;
                margin-top: 6px;
                margin-left: 5px;
                font-size: 14px;
              "
            >
              <small
                ><strong>{{ item.competicao }}</strong></small
              >
            </h6>
          </div>

          <div
            class="list-group-item text-left"
            v-if="filtroSituacao.indexOf(item.situacao) > -1"
            :style="{
              'margin-bottom':
                itensFiltro[itemIndex + 1] &&
                itensFiltro[itemIndex + 1].competicao == item.competicao
                  ? '0px'
                  : '4px',
              'border-bottom-width':
                itensFiltro[itemIndex + 1] &&
                itensFiltro[itemIndex + 1].competicao == item.competicao
                  ? '0px'
                  : '1px',
            }"
          >
            <div class="row">
              <div
                class="col col-md-12 d-flex justify-content-between"
                style="padding-left: 10px"
              >
                <div class="d-flex align-items-center prevent-select">
                  <span style="padding-top: 6px; padding-right: 8px">
                    <button
                      class="favorito"
                      :class="{
                        ativo: itensFavoritos[item._id] ? true : false,
                      }"
                      @click="favorito(item)"
                    >
                      <i
                        class="fa"
                        :class="{
                          'fa-star-o': itensFavoritos[item._id] ? false : true,
                          'fa-star': itensFavoritos[item._id] ? true : false,
                        }"
                        aria-hidden="true"
                      ></i>
                    </button>
                  </span>
                  <h6 style="margin-top: 3px; margin-bottom: 0px">
                    <small>
                      {{ formatarHora(item) }}
                    </small>
                    -
                    <span
                      style="cursor: pointer"
                      @click="abrirEvento(item, false)"
                      >{{ item.nome }}</span
                    >
                    <small v-if="item.situacao == 2">
                      <small>Invisivel</small>
                    </small>
                  </h6>
                </div>
                <div
                  style="margin-top: 0px; min-width: 78px"
                  v-if="
                    item.situacao == 3 ||
                    (retornaTipoUsuario() == 'Administrador' || retornaTipoUsuario() == 'Apresentador')
                  "
                  class="text-right d-flex align-items-center"
                >
                  <button
                    type="button"
                    @click="abrirEvento(item, false)"
                    class="btn btn-sm btn-dark"
                    style="margin-right: 10px; font-size: 8px"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Com radar"
                    v-if="retornaSite() !== '7live'"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-bar-chart-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    @click="abrirEvento(item, true)"
                    class="btn btn-sm btn-dark"
                    style="font-size: 8px"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Sem radar"
                    v-if="
                      retornaTipoUsuario() == 'Administrador' ||
                      retornaTipoUsuario() == 'Apresentador' ||
                      retornaSite() !== '7live' ||
                      (retornaSite() == '7live' && planoAtivo == true) ||
                      (retornaSite() == '7live' &&
                        planoAtivo == false &&
                        itensUsuario.hasOwnProperty(item._id))
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-aspect-ratio"
                      viewBox="0 0 16 16"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Sem radar"
                    >
                      <path
                        d="M0 3.5A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5v-9zM1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"
                      ></path>
                      <path
                        d="M2 4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H3v2.5a.5.5 0 0 1-1 0v-3zm12 7a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H13V8.5a.5.5 0 0 1 1 0v3z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    @click="adquirirEvento(item)"
                    class="btn btn-sm btn-outline-dark"
                    style="margin-left: 10px; font-size: 8px"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Comprar"
                    v-if="
                      retornaTipoUsuario() !== 'Administrador' &&
                      retornaTipoUsuario() !== 'Apresentador' &&
                      retornaSite() == '7live' &&
                      planoAtivo == false &&
                      !itensUsuario.hasOwnProperty(item._id)
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-cart2"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <EditPlanoUsuarioPublico
        ref="editPlanoUsuarioPublico"
        @fechar="fecharAdquirirEvento()"
        propView="evento"
      />
    </div>
  </div>
</template>

<script>
import EditPlanoUsuarioPublico from "../edits/EditPlanoUsuarioPublico";
import { api } from "@/services/api.js";

export default {
  name: "ListEvento",
  components: { EditPlanoUsuarioPublico },
  props: {
    itens: { type: Array },
    itensUsuario: {
      type: Object,
      default() {
        return {};
      },
    },
    itensFavoritos: {
      type: Object,
      default() {
        return {};
      },
    },
    filtroSituacao: { type: Array, default: () => [] },
    icone: { type: Boolean, default: true },
    loadGif: { type: Boolean, default: false },
    planoAtivo: { type: Boolean, default: false },
    gmt: { type: Number, default: -3 },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    retornaTipoUsuario() {
      return this.$sessao ? this.$sessao.usuario.tipoUsuario : "";
    },
    formatarHora(evento) {
      var hora = evento.dataHora.toString().padStart(2, "0");
      var minuto = evento.dataMinuto.toString().padStart(2, "0");

      try {
        var data = new Date();
        data.setHours(evento.dataHora + 3 + parseInt(this.gmt));
        data.setMinutes(evento.dataMinuto);

        hora = data.getHours();
        minuto = data.getMinutes();
      } catch (err) {
        console.log(err);
      }

      return (
        hora.toString().padStart(2, "0") +
        ":" +
        minuto.toString().padStart(2, "0")
      );
    },
    abrirEvento(item, limpo) {
      var url = "/view/" + item._id;

      if (limpo) {
        url = url + "?view=clean";
      }

      if (
        item.situacao == 3 ||
        this.$sessao.usuario.tipoUsuario == "Administrador"
      ) {
        window.open(
          url,
          "newwindow_" + Date.now(),
          "scrollbars=1,width=450,height=690"
        );
      }
    },
    favorito(item) {
      if (this.itensFavoritos[item._id]) {
        delete this.itensFavoritos[item._id];
        api.put("/favorito", { evento: item._id });
      } else {
        this.itensFavoritos[item._id] = true;
        api.post("/favorito", { evento: item._id });
      }

      this.forceRerender();

      var thisCall = this;

      if (this.timeoutCarregarItens !== null) {
        clearTimeout(this.timeoutCarregarItens);
      }

      this.timeoutCarregarItens = null;

      this.timeoutCarregarItens = setTimeout(function () {
        thisCall.$emit("carregarItens");
      }, 2000);
    },
    async adquirirEvento(item) {
      await this.$refs.editPlanoUsuarioPublico.carregarItemEvento(item);
      this.$refs.editPlanoUsuarioPublico.abrir();
    },
    fecharAdquirirEvento() {
      this.$emit("recarregar");
    },
    forceRerender() {
      this.componentKey += 1;
    },
  },
  mounted() {
    //window.$('[data-toggle="tooltip"]').tooltip();
  },
  computed: {
    quantidadeItens: function () {
      var filtroSituacao = this.filtroSituacao;

      return this.itens.filter(function (item) {
        return filtroSituacao.indexOf(item.situacao) > -1;
      }).length;
    },
    itensFiltro: function () {
      var filtroSituacao = this.filtroSituacao;

      return this.itens.filter(function (item) {
        return filtroSituacao.indexOf(item.situacao) > -1;
      });
    },
  },
  data: function () {
    return {
      componentKey: 1,
      timeoutCarregarItens: null,
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}

/*
.rowListaEventosHome .list-group-item {
  border-color:black;
  border-bottom:0px;
}

.rowListaEventosHome > .list-group-item:last-child {
  border-bottom:1px solid black;
}*/
</style>
